import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './styles/tae.css';

const ServiceApply = ({ history }) => {
  
  return (
    <Container>
      <section className='request'>
        <p className='request__title' style={{ fontSize:"40px" }}>서비스 신청 </p>
        <p className='request__subtitle'>아비스의 서비스(신차 서비스, 카케어 서비스)를 이용해 보세요</p>
        <Row className='request__content'>
          <Col xs={5}>
            <img src='/abys_test.png' className='request__content__img'/>
          </Col>
          <Col className='ml-5'>
            <p className='request__content__title'>썬가드하이퍼이벤트</p>
            <p className='request__content__subtitle'>공지사항이 들어가는 부분입니다. 에디터를 이용해주세요</p>
            <p className='request__content__desc'>
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다. 
              공지사항이 들어가는 부분입니다.  에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
            </p>
            <NavLink className='btn request__btn' to='/serviceall?cate=sungard' >썬가드하이퍼이벤트 바로가기</NavLink>
          </Col>
        </Row>
        <Row className='request__content'>
          <Col className='mr-5'>
            <p className='request__content__title'>현대캐피탈서비스</p>
            <p className='request__content__subtitle'>공지사항이 들어가는 부분입니다. 에디터를 이용해주세요</p>
            <p style={{fontWeight: 'bold', fontSize: '20px', lineHeight: '24px', marginTop: '30px' }}>주요 서비스</p>
            <p className='request__content__desc'>
              실내 클리닝, 디테일링 세차, 전기차 케어, 신차 유리막 코팅, 스팀세차, 난반사 교정 광택, 심화정통 광택, 일반, 정통 유리막 코팅, 블랙박스 설치
            </p>
            <NavLink className='btn request__btn' to='/serviceall?cate=hyundai'>현대캐피탈서비스 바로가기</NavLink>
          </Col>
          <Col xs={5}>
            <img src='/abys_test.png' className='request__content__img'/>
          </Col>
        </Row>
        <Row className='request__content'>
          <Col xs={5}>
            <img src='/abys_test.png' className='request__content__img'/>
          </Col>
          <Col className='ml-5'>
            <p className='request__content__title'>SC글로벌 B to B</p>
            <p className='request__content__subtitle'>공지사항이 들어가는 부분입니다. 에디터를 이용해주세요</p>
            <p className='request__content__desc'>
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다. 
              공지사항이 들어가는 부분입니다.  에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
              공지사항이 들어가는 부분입니다. 에디터를 이용해 사진을 자유자재로 넣을 수 있습니다.
            </p>
            <NavLink className='btn request__btn' to='/serviceall?cate=BtoB' >SC글로벌B to B 바로가기</NavLink>
          </Col>
        </Row>
      </section>
    </Container>
  );
}

export default ServiceApply;
